import { render } from "./End.vue?vue&type=template&id=b2fc57ba"
import script from "./End.vue?vue&type=script&lang=js"
export * from "./End.vue?vue&type=script&lang=js"

import exportComponent from "C:\\projects\\Bleckmann\\lions-adventskalender-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__